module.exports = __webpack_public_path__ + "static/media/calendar.cfdf0259.svg";